<template>
  <div class="box--details">
    <div id="stripe-card"></div>
  </div>
</template>

<script>
import stripeHandler from '../../services/payment/stripeHandler'

export default {
  components: {},
  data () {
    return {
      orderId: null,
      currentUser: null,
      error: 'Kortuppgifter ej ifyllt',
      stripeKey: '',
      stripeTestKey: 'pk_test_51HO0SPBM3YUogT7XuzJh19o5BqUrJkr8557Db8Jkj6fRpOjkmTazvvGAsZltnuUMo1hd3Am51b9SAHwoENdmfmsc00JmelA6iN',
    }
  },
  async mounted () {
    this.orderid = this.$store.getters.currentOrderId
    this.currentUser = this.$store.getters.currentUser
    this.initStripe()
  },
  methods: {
    async initStripe () {
      // eslint-disable-next-line
      this.stripe = await Stripe(this.stripeTestKey)
      // Create an instance of Elements.
      this.elements = this.stripe.elements()

      // Create an instance of the card Element.
      this.card = this.elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            color: 'white',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#CFD7DF',
            },
          },
          invalid: {
            color: '#e5424d',
            ':focus': {
              color: '#303238',
            },
          },
        },
      })

      // Add an instance of the card Element into the `card-element` <div>.
      this.card.mount('#stripe-card')

      // Handle real-time validation errors from the card Element.

      this.card.on('change', event => {
        if (event.error) {
          this.error = event.error.message
        } else {
          this.error = ''
          this.$emit('newState', {
            id: 0,
            msg: '',
          })
        }
      })
    },

    async handleNext () {
      if (this.error) {
        return this.$emit('newState', {
          id: 2,
          msg: this.error,
        })
      }

      this.$emit('newState', {
        id: 3,
        msg: 'Förbereder betalning',
      })

      try {
        const session = await stripeHandler.startStripeSubscription({
          order: { id: this.orderid },
        })

        try {
          const result = await this.stripe.confirmCardPayment(
            session.client_secret,
            {
              payment_method: {
                card: this.card,
                billing_details: {
                  // Name from local fields
                  // name: this.currentUser.name,
                },
              },
            }
          )

          // https://stripe.com/docs/api/errors
          if (result.error) {
            // Inform the user if there was an error.
            return this.$emit('newState', {
              id: 2,
              msg: result.error.message,
            })
          }

          if (result.paymentIntent.status === 'succeeded') {
            this.$emit('newState', {
              id: 3,
              msg: 'Betalning genomförd, skapar order',
            })

            try {
              await stripeHandler.getStripeStatus({
                paymentIntent: result.paymentIntent.id,
                orderId: this.orderId,
              })

              this.$emit('newState', {
                id: 1,
                msg: 'Betalning genomförd',
              })

              return this.$emit('next')
            } catch (err) {
              return this.handlePaymentSuccessWithError(err, session)
            }
          }
        } catch (err) {
          console.log(err)
        }
      } catch (err) {
        this.$emit('newState', {
          id: 2,
          msg: this.$errorHelper(err),
        })
      }
    },

    async handlePaymentSuccessWithError (err, session) {
      // Trigger bugs
      this.$errorHelper({ rawError: err })
      // Stripe payment went throught, but firebase webhook error occured
      /*
      orderHandler.handlePaymentSuccessWithError({
        id: this.order.id,
        paymentMethod: 'stripe',
        paymentMethodId: session.id,
      })
      */

      this.$emit('newState', {
        id: 2,
        msg: this.$errorHelper({
          code: 'ST-PAYMENT-SUCCESS',
          message:
            'Betalningen genomförd men ett internt fel har skett. Vänligen kontakta support för hjälp.',
        }),
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variables';
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  border: none;
  border: 1px solid white;
  background: rgba(0, 0, 0, 0.01);
  box-shadow: 0px 0px 2px rgba(@color-black, 0.3) !important;
  padding: 12px;
  -webkit-appearance: none;
  width: 100%;
  transition: all 0.2s;
}
/*
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;

}
*/

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
